<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class="rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">our_work</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">heading</p>
                <textarea v-model="fieldJsonData.heading"
                :class="heading_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                ></textarea>
                <p v-if="heading_err" class="text-error heading-6">heading is required</p>
              </div>
              <!-- <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">description</p>
                <textarea v-model="fieldJsonData.description"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="description"
                ></textarea>
              </div> -->
            </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">card_list</p>
           <div v-for="(data, index) in fieldJsonData.card_list" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">heading</p>
                    <textarea v-model="data.heading"
                    :class="data.heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    ></textarea>
                    <p v-if="data.heading_err" class="text-error heading-6">heading is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">description</p>
                    <textarea v-model="data.description"
                    :class="data.description_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="description"
                    ></textarea>
                    <p v-if="data.description_err" class="text-error heading-6">description is required</p>
                </div>
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">heading_style</p>
                    <textarea v-model="data.heading_style"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading_style"
                    ></textarea>
                </div> -->
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_1_url</p>
                    <input v-model="data.img_1_url"
                    :class="data.img_1_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_1_url"
                    >
                    <p v-if="data.img_1_url_err" class="text-error heading-6">img_1_url is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_1_alt</p>
                    <input v-model="data.img_1_alt"
                    :class="data.img_1_alt_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_1_alt"
                    >
                    <p v-if="data.img_1_alt_err" class="text-error heading-6">img_1_alt is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_2_url</p>
                    <input v-model="data.img_2_url"
                    :class="data.img_2_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_2_url"
                    >
                    <p v-if="data.img_2_url_err" class="text-error heading-6">img_2_url is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_2_alt</p>
                    <input v-model="data.img_2_alt"
                    :class="data.img_2_alt_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_2_alt"
                    >
                    <p v-if="data.img_2_alt_err" class="text-error heading-6">img_2_alt is required</p>
                </div>
                <div v-if="fieldJsonData.card_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      heading_err: false,
      isError: true,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   heading: "",
      //   description: null,
      //   card_list: [
      //       {
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_1_url: "",
      //       img_1_url_err: false,
      //       img_1_alt: "",
      //       img_1_alt_err: false,
      //       img_2_url: "",
      //       img_2_url_err: false,
      //       img_2_alt: "",
      //       img_2_alt_err: false
      //       },
      //       {
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_1_url: "",
      //       img_1_url_err: false,
      //       img_1_alt: "",
      //       img_1_alt_err: false,
      //       img_2_url: "",
      //       img_2_url_err: false,
      //       img_2_alt: "",
      //       img_2_alt_err: false
      //       },
      //       {
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_1_url: "",
      //       img_1_url_err: false,
      //       img_1_alt: "",
      //       img_1_alt_err: false,
      //       img_2_url: "",
      //       img_2_url_err: false,
      //       img_2_alt: "",
      //       img_2_alt_err: false
      //       }
      //   ]
      // }
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
    }
  },
  mounted () {
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.heading !== '') {
          this.heading_err = false
          this.isError = false
        }
        for (let index = 0; index < this.fieldJsonData.card_list.length; index++) {
          if (this.fieldJsonData.card_list[index].heading !== '') {
            this.fieldJsonData.card_list[index].heading_err = false
            this.isError = false
          }
          if (this.fieldJsonData.card_list[index].description !== '') {
            this.fieldJsonData.card_list[index].description_err = false
            this.isError = false
          }
          if (this.fieldJsonData.card_list[index].img_1_url !== '') {
            this.fieldJsonData.card_list[index].img_1_url_err = false
            this.isError = false
          }
          if (this.fieldJsonData.card_list[index].img_1_alt !== '') {
            this.fieldJsonData.card_list[index].img_1_alt_err = false
            this.isError = false
          }
          if (this.fieldJsonData.card_list[index].img_2_url !== '') {
            this.fieldJsonData.card_list[index].img_2_url_err = false
            this.isError = false
          }
          if (this.fieldJsonData.card_list[index].img_2_alt !== '') {
            this.fieldJsonData.card_list[index].img_2_alt_err = false
            this.isError = false
          }
        }
      },
      deep: true
    }
  },
  methods: {
    addCardDetails () {
      this.fieldJsonData.card_list.push({
        back_color: "",
        description: "",
        heading: "",
        img_1_url: ""
      })
      console.log("addddddd", this.fieldJsonData.card_list);
    },
    removeCardDetails (index) {
      if (this.fieldJsonData.card_list.length !== 1) {
        this.fieldJsonData.card_list.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.card_list);
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      if (this.fieldJsonData.heading === '') {
        this.heading_err = true
        this.isError = true
      }
      for (let index = 0; index < this.fieldJsonData.card_list.length; index++) {
          if (this.fieldJsonData.card_list[index].heading === '') {
            this.fieldJsonData.card_list[index].heading_err = true
            this.isError = true
          }
          if (this.fieldJsonData.card_list[index].description === '') {
            this.fieldJsonData.card_list[index].description_err = true
            this.isError = true
          }
          if (this.fieldJsonData.card_list[index].img_1_url === '') {
            this.fieldJsonData.card_list[index].img_1_url_err = true
            this.isError = true
          }
          if (this.fieldJsonData.card_list[index].img_1_alt === '') {
            this.fieldJsonData.card_list[index].img_1_alt_err = true
            this.isError = true
          }
          if (this.fieldJsonData.card_list[index].img_2_url === '') {
            this.fieldJsonData.card_list[index].img_2_url_err = true
            this.isError = true
          }
          if (this.fieldJsonData.card_list[index].img_2_alt === '') {
            this.fieldJsonData.card_list[index].img_2_alt_err = true
            this.isError = true
          }
      }
      if (this.isError === false) {
        for (let index = 0; index < this.fieldJsonData.card_list.length; index++) {
            delete this.fieldJsonData.card_list[index].heading_err
            delete this.fieldJsonData.card_list[index].description_err
            delete this.fieldJsonData.card_list[index].img_1_url_err
            delete this.fieldJsonData.card_list[index].img_1_alt_err
            delete this.fieldJsonData.card_list[index].img_2_url_err
            delete this.fieldJsonData.card_list[index].img_2_alt_err
        }
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>